import {createApp} from 'vue'
import App from './App.vue'
// Default Konfiguration
import defaults from './config.js'
// App wird im Element mit der ID glasses-main-app eingeblendet
const  rootelement =  document.getElementById("glasses-main-app");

// Über die Element-Attribute von glasses-main-app können ebenfalls Konfigurationen definiert werden.
// Dies ermöglicht Seiten z.B. mit gesetzten Filtern z.B. für Damensonnenbrillen anzuzeigen
const attributenames = rootelement.getAttributeNames();
let attributes = {}
// Daten-Attribute mit prefix data-cfg einlesen
attributenames.forEach(function(el) {
    if(el.indexOf('data-cfg-') === 0) {
        attributes[el.substr(9)] = isNaN(parseInt(rootelement.getAttribute(el))) ? rootelement.getAttribute(el) : parseInt(rootelement.getAttribute(el))
    }
})

//Defaults aus config.js werden von Konfigurationen aus Elementattributen überschrieben
const options = { ...defaults, ...attributes}

// Create APP
const vue = createApp(App, {
    data() {
        return defaults
    },
    cfg: options
}, options).mount('#glasses-main-app')

vue.config = { ...defaults, ...attributes}
